import { isEmpty, isNullish } from 'remeda';

import { DetailedTournamentGroupModel, TournamentGroupModel } from 'v2/types/TournamentGroupModel';
import { TournamentModel } from 'v2/types/TournamentModel';

export function toDetailedGroups(
  groupsData?: TournamentGroupModel[],
  tournamentsData?: TournamentModel[]
): DetailedTournamentGroupModel[] {
  if (isNullish(groupsData) || isEmpty(groupsData)) return [];

  const tournaments = tournamentsData ?? [];

  const tournamentsByGroupIds = new Map<string, TournamentModel[]>();

  for (const tournament of tournaments) {
    if (!tournament.groupId) continue;

    const tournamentsByGroupId = tournamentsByGroupIds.get(tournament.groupId);

    if (tournamentsByGroupId) {
      tournamentsByGroupId.push(tournament);
    } else {
      tournamentsByGroupIds.set(tournament.groupId, [tournament]);
    }
  }

  return groupsData.map((group) => {
    const groupTournaments = tournamentsByGroupIds.get(group.id) ?? [];
    const tournamentNames = groupTournaments.map((t) => t.name);
    const firstTournament = groupTournaments.find((t) => t.isFirstInGroup);
    const lastTournament = groupTournaments.find((t) => t.isLastInGroup);

    return {
      ...group,
      startDate: firstTournament?.startDate,
      endDate: lastTournament?.endDate,
      tournaments: tournamentNames,
    };
  });
}
